// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"23":"df0f06a1","101":"bfad09b5","108":"cc582b29","445":"cc582b29","478":"cc582b29","527":"cc582b29","653":"e964c647","877":"cc582b29"}[chunkId] + ".chunk.css";
};